import {
    createMountsBottomFrameSortConfig,
    createMountsGlazingGasketConfig,
    createMountsSideFrameSortConfig,
    createMountsStripesConfig,
    createMountsTopFrameSortConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSlidingDoorMountsTopFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const qty = MountsService.getTopFrameWidth(partition);

    return createMountsTopFrameSortConfig().qty(0).area(qty).build();
};

const createSlidingDoorMountsSideFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const totaleHeight = MountsService.getTotalHeight(partition);
    const sides = 2;

    const qty = Math.round(totaleHeight * sides) || 0;

    return createMountsSideFrameSortConfig().qty(0).area(qty).build();
};

const createSlidingDoorMountsBottomFrameSortConfig = (
    partition: Partition,
): IComponentConfig => {
    const qty = MountsService.getBottomFrameWidth(partition);

    return createMountsBottomFrameSortConfig().qty(0).area(qty).build();
};

const createSlidingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);

    const sides = 2;

    const horizontalGaskets = totalWidth * sides;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0;//inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

const createSlidingDoorMountsStripesConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const lines = MountsService.getStipJointsQty(partition);
    // const length = lines * totalWidth;

    return createMountsStripesConfig()
        .qty(lines)
        .area(lines)
        .width(totalWidth)
        .build();
};

export const CGS200NoDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsTopFrameSortConfig(partition),
    createSlidingDoorMountsSideFrameSortConfig(partition),
    createSlidingDoorMountsBottomFrameSortConfig(partition),
    createSlidingDoorMountsGlazingGasketConfig(partition),
    createSlidingDoorMountsStripesConfig(partition),
];
